module.exports = __webpack_public_path__ + "media/bgVideo.2e32d5e2.mp4";